import { getAcademyHostContext, isAcademySubdomainHost, type AcademyHostContext } from './academyHost';

export type TenantHostMode = 'path' | 'subdomain';

export interface TenantSubdomainContext {
  mode: TenantHostMode;
  /** Subdomain label from hostname (subdomain mode only). */
  subdomainLabel?: string;
}

/** @deprecated Use getTenantSubdomainContext */
export const getAcademyHostContextAlias = getAcademyHostContext;

/**
 * Resolve whether the current host is path-based or tenant subdomain-based.
 * Alias-friendly replacement for academy-only host detection.
 */
export function getTenantSubdomainContext(hostname?: string): TenantSubdomainContext {
  return getAcademyHostContext(hostname);
}

export function isTenantSubdomainHost(hostname?: string): boolean {
  return getAcademyHostContext(hostname).mode === 'subdomain';
}

/** @deprecated Use isTenantSubdomainHost */
export { isAcademySubdomainHost };

export type { AcademyHostContext as TenantHostContext };
